import { render, staticRenderFns } from "./import-envios.vue?vue&type=template&id=14aa165a"
import script from "./import-envios.vue?vue&type=script&lang=ts"
export * from "./import-envios.vue?vue&type=script&lang=ts"
import style0 from "./import-envios.vue?vue&type=style&index=0&id=14aa165a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports